import {get, post, put, del} from '../../actions/apiMethods';
// import {get, post, put, del} from './apiMethods';

const crud = (slug, service = 'api') => ({
  fetchAll: () => get(`${service}/${slug}`),
  fetchById: (id) => get(`${service}/${slug}/${id}`),
  create: (json) => post(`${service}/${slug}`, json),
  update: (id, json) => put(`${service}/${slug}/${id}`, json),
  remove: (id) => del(`${service}/${slug}/${id}`),
  removeMultiple: (ids) => post(`${service}/${slug}/delete`, { ids }),
});

// const crud = (slug) => ({
//   fetchAll: () => get(`api/configurations/${slug}`),
//   fetchById: (id) => get(`api/configurations/${slug}/${id}`),
//   create: (json) => post(`api/configurations/${slug}`, json),
//   update: (id, json) => put(`api/configurations/${slug}/${id}`, json),
//   remove: (id) => del(`api/${slug}/configurations/${id}`),
//   removeMultiple: (ids) => post(`api/configurations/${slug}/delete`, { ids }),
// });

export const system = {
  ...crud('configurations/system'),
};

export const server = {
  ...crud('api/server', 'mms-agg'),
  syncServer: (id) => get(`mms-agg/api/server/${id}/sync`),
}


// WEBPACK FOOTER //
// ./src/components/SystemConfiguration/api.js